import React from 'react'

const ColorCell = ({selected, variant, supCellStyle, id, palette, setPalette, setButtonState, handleSelected}) => {
  let cellStyle = {backgroundColor: variant, ...supCellStyle}

  if (selected === true) {
    cellStyle = {backgroundColor: variant, ...supCellStyle, border: "4px double"}
  }
  const handleSelect = (e) => {
    if (id === 'none') {
      return
    }
    for (let i = 0; i < palette.length; i++) {
      if (i === Number(id)) {
        if (palette[i] === e.currentTarget.innerText.toLowerCase()) {
          return
        }
        palette[i] = e.currentTarget.innerText.toLowerCase()
      }
    }
    const newPalette = [...palette]
    setPalette(newPalette)
    setButtonState("Save")
  }
  return (
    <div style={cellStyle} className='solo-cell' onClick={(e) => {
      handleSelect(e)
      handleSelected(e, id)
    }}>{variant}</div>
  )
}

export default ColorCell